/**
 * @desc 公司ComeOnStatistical接口
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.CompanyComeOnStatisticalPagingConditions>): Promise<BaseResponse<defs.PageBean<Array<defs.ComeOnStatisticsPagingInformationCompany>>>> {
  return fetch({
    url: config.API_HOST + '/statistics/getCompanyPetrolStatPage',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
